import { Cookies } from '../constants/cookies';

export const getCampaignCookie = (document: Document) => {
  const cookieName = Cookies.GTM_CAMPAIGN;

  const cookieValue = document
    ? document.cookie
      .split('; ')
      .find(
        (row: string) => row.startsWith(`${cookieName}=`)
      )?.split('=')[1]
    : undefined;
    
  return cookieValue === undefined
    ? []
    : decodeURIComponent(cookieValue)
      .split('?')[1]
      ?.split('&')
      .filter(param =>
        param.includes('utm_') || param.includes('referred_by') || param.includes('gclid') || param.includes('at_')
      );
};
